import { render, staticRenderFns } from "./politicsProjectFlow.vue?vue&type=template&id=87be84e2&scoped=true"
import script from "./politicsProjectFlow.vue?vue&type=script&lang=js"
export * from "./politicsProjectFlow.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectFlow.vue?vue&type=style&index=0&id=87be84e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be84e2",
  null
  
)

export default component.exports